/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountNavContent_user = {
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly conversationSummary: {
        readonly unread: number | null;
    } | null;
    readonly " $refType": "AccountNavContent_user";
};
export type AccountNavContent_user$data = AccountNavContent_user;
export type AccountNavContent_user$key = {
    readonly " $data"?: AccountNavContent_user$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountNavContent_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "AccountNavContent_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "conversationSummary",
      "storageKey": null,
      "args": null,
      "concreteType": "Summary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "unread",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '8997779c90abeb18372127fb77957faa';
export default node;
